import { type NavigationPageType } from '@blaze-shared/projects-domain';

import {
  type NavigationContainerVariantType,
  type NavigationElementType,
} from './element-taxonomy';

const navElementTypeToPageType: Record<NavigationElementType, NavigationPageType> = {
  navContainer: 'Header',
  navSidebar: 'Sidebar',
  navBottombar: 'Bottombar',
};

const navContainerElementTypeToPageType: Record<
  NavigationContainerVariantType,
  NavigationPageType
> = {
  navHeaderContainer: 'Header',
  navSidebarContainer: 'Sidebar',
  navBottombarContainer: 'Bottombar',
};

const pageTypeToNavElement: Record<
  NavigationPageType,
  { host: NavigationElementType; container: NavigationContainerVariantType }
> = {
  Header: { host: 'navContainer', container: 'navHeaderContainer' },
  Sidebar: { host: 'navSidebar', container: 'navSidebarContainer' },
  Bottombar: { host: 'navBottombar', container: 'navBottombarContainer' },
};

export function navigationElementTypeToPageType(type: NavigationElementType): NavigationPageType {
  return navElementTypeToPageType[type];
}

export function navigationContainerElementTypeToPageType(
  type: NavigationContainerVariantType,
): NavigationPageType {
  return navContainerElementTypeToPageType[type];
}

export function PageTypeToNavigationElementType(type: NavigationPageType): NavigationElementType {
  return pageTypeToNavElement[type].host;
}

export function PageTypeToNavigationContainerElementType(
  type: NavigationPageType,
): NavigationContainerVariantType {
  return pageTypeToNavElement[type].container;
}
